import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import Button from '../../components/common/Button';
import Input from '../../components/common/Input';
import Alert from '../../components/common/Alert';
import { authApi } from '../../services/api';
import './ForgotPassword.css';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!email) {
            setError('Email is required');
            return;
        }

        setLoading(true);
        setError('');

        try {
            await authApi.forgotPassword({ email });
            setSuccess(true);
        } catch (err) {
            setError(err.response?.data?.error?.message || 'Failed to send reset email');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="forgot-password-container">
            <div className="forgot-password-box">
                <div className="forgot-password-header">
                    <div className="forgot-password-logo">
                        <div className="logo-icon">EP</div>
                    </div>
                    <h1>Forgot Password</h1>
                    <p>Enter your email to receive a password reset link</p>
                </div>

                {success ? (
                    <div className="forgot-password-success">
                        <div className="success-icon">
                            <CheckCircle size={48} />
                        </div>
                        <h2>Check Your Email</h2>
                        <p>
                            We have sent a password reset link to <strong>{email}</strong>.
                            Please check your inbox and follow the instructions.
                        </p>
                        <Link to="/login" className="back-to-login">
                            <ArrowLeft size={16} />
                            Back to Login
                        </Link>
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="forgot-password-form">
                        {error && (
                            <Alert type="error">{error}</Alert>
                        )}

                        <Input
                            type="email"
                            label="Email Address"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => {
                                setEmail(e.target.value);
                                setError('');
                            }}
                            icon={Mail}
                            required
                        />

                        <Button type="submit" fullWidth loading={loading}>
                            Send Reset Link
                        </Button>

                        <Link to="/login" className="back-to-login">
                            <ArrowLeft size={16} />
                            Back to Login
                        </Link>
                    </form>
                )}
            </div>
        </div>
    );
}
